import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * Panel Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Title of the Component
     */
    @Prop() title!: string;

    /**
     * Subtitle of the Component
     */
    @Prop() subtitle!: string;

    /**
     * Open Panel (Collapse) Icon
     */
    @Prop({ default: 'chevron-up' }) openPanelIcon!: string;

    /**
     * Close Panel (Collapse) Icon
     */
    @Prop({ default: 'chevron-down' }) closePanelIcon!: string;

    /**
     * Icon Size
     * Apply on title icon, open and close icon
     */
    @Prop({ default: 'small' }) iconSize!: string;

    /**
     * Icons library code name. here's a list of supported icons libraries:
     * 'mdi' - Material Design Icons - https://materialdesignicons.com/
     * 'fa' - Font Awesome - https://fontawesome.com/icons
     */
    @Prop({ type: String, default: 'fa' }) iconLibrary!: string;

    /**
     * Prefix of the icon
     * Font Awesome prefix: 'fab', 'far', 'fas'.
     */
    @Prop({ type: String, default: 'fas' }) iconPrefix!: string;

    /**
     * Makes panel collapsible
     */
    @Prop({ type: Boolean }) collapsible!: boolean;

    /**
     * Default Collapsing Mode
     */
    @Prop({ type: Boolean }) collapsed!:boolean;

    /**
     * Remove Padding of the Panel
     */
    @Prop({ type: Boolean }) noPadding!:boolean;
}

export default Props;
